<template>
  <div class="p-header-breadcrumb-link">
    <i v-if="itemKey > 0" class="p-header-breadcrumb-link__arrow">></i>
     <component
          :is="tag"
          v-touch:tap
          v-bind="tag === 'a' ? { href: url } : {}"
          :class="[linkItemClassNameBase, currentLinkClassName]"
          @click="clickDisable"
      >
      <span v-if="isLower">{{ text }}</span>
      <component :is="componentName" v-else />
    </component>
  </div>
</template>

<script lang="ts">
import BreadcrumbLinkIsHome from "@/common/components/atoms/BreadcrumbLinkIsHome.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    url: { type: String, default: "" },
    lastElement: { type: Boolean, default: false },
    text: { type: String, default: "現在のページ" },
    pageType: { type: String, default: "lower" },
    itemKey: { type: Number, default: 0 }
  },
  components: {
    BreadcrumbLinkIsHome
  }
})
export default class BreadcrumbLink extends Vue {
  url!: string;
  lastElement!: boolean;
  text!: string;
  pageType!: string;
  itemKey!: number;

  linkItemClassNameBase = "p-header-breadcrumb-link__item";
  componentBaseName = "breadcrumb-link";

  get tag() {
    return this.url === "" ? "span" : "a";
  }

  get currentLinkClassName() {
    return this.lastElement
      ? `${this.linkItemClassNameBase}--current-page`
      : "";
  }

  get isHome() {
    return this.pageType === "home";
  }

  get isLower() {
    return this.pageType === "lower";
  }

  get componentName() {
    return `${this.componentBaseName}-is-${this.pageType}`;
  }

  clickDisable(e: any) {
    if (this.lastElement) {
      e.preventDefault();
    }
  }
}
</script>

<style lang="scss" scoped>
.p-header-breadcrumb-link {
  display: inline-block;
  vertical-align: middle;

  &__arrow {
    font-size: rem(12);
  }

  &__item {
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    align-items: center;
    font-feature-settings: 'palt' on, 'pwid' on;
    color: #bdbdbd;
    padding-right: rem(4);

    @include sp {
      font-size: 10px;
    }

    &.tap {
      text-decoration: underline;
    }

    &--current-page {
      color: $color;

      &.tap,
      &:active,
      &:focus {
        text-decoration: none;
        cursor: text;
      }
    }
  }
}
</style>
